/* eslint-disable max-len */
import universal from 'react-universal-component';

export const OptimizelyModal = universal(import(/* webpackChunkName: "OptimizelyModal" */'./OptimizelyModal'));
